import { render, staticRenderFns } from "./thirdStep.vue?vue&type=template&id=7af6fcb4&scoped=true"
import script from "./thirdStep.vue?vue&type=script&lang=js"
export * from "./thirdStep.vue?vue&type=script&lang=js"
import style0 from "./thirdStep.vue?vue&type=style&index=0&id=7af6fcb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af6fcb4",
  null
  
)

export default component.exports